import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";

import { useHistory, useParams } from "react-router-dom";

import Select from "react-select";
import makeAnimated from "react-select/animated";

import { Button } from "../../elements/Button";
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/searchPri.svg";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete_icon_primary.svg";
import Breadcrumb from "../../components/Breadcrumb";
import Sidebar from "../../elements/Sidebar";
import bookclosuretablecss from "../../css/bookclosuretable.module.css";
import tablecss from "../../css/table.module.css";
import libcss from "../../css/library.module.css";

import { customStyles } from "../../../Bookclosure/Components/AddTaskModal";
import InputGroup from "../../elements/InputGroup";
import CustomDropdownIndicator from "../../elements/CustomDropdownIndicator";
import saCreationcss from "../../css/standaloneCreation.module.css";

import GeneralTemplateInfo from "./GeneralTemplateInfo";
import Hierarchy from "./Hierarchy";
import Notes from "./Notes";
import Socie from "./Socie";
import Disclosures from "./Disclosures";
import { getTemplateDetailsApiHandler } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import Cashflow from "./Cashflow";

const ViewEditLibrary = () => {
  const animatedComponents = makeAnimated();

  let history = useHistory();
  const dispatch = useDispatch();
  const [fs, setFs] = useState([]);
  const [libraryName, setLibraryName] = useState("ST Library");

  const [templateData, setTemplateData] = useState({});
  const [edit, setEdit] = useState(false);
  const [tab, setTab] = useState("general");
  const [showBin, setShowBin] = useState(null);
  const [handleSave, setHandleSave] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(true);

  const { tempId } = useParams();

  const breadcrumbItems = [
    {
      label: "Template Library",
      link: `/myfinv2/library/standalone-library`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: `${libraryName}`, link: "", className: "headerLable" },
  ];

  useEffect(() => {
    getTemplateDetails();
  }, []);

  const getTemplateDetails = () => {
    getTemplateDetailsApiHandler({ groupingTemplateID: tempId })
      .then((response) => {
        if (response?.data?.success === true) {
          setTemplateData(response?.data?.groupingTemplate);
          console.log(
            "response?.data?.groupingTemplate",
            response?.data?.groupingTemplate
          );
          setIsReadOnly(
            response?.data?.groupingTemplate?.templateType === "default"
              ? true
              : false
          );
        }
      })
      .catch((error) => {
        // setCompanyData({});
      });
  };

  return (
    <>
      <div>
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className={commoncss.w100}
            style={{ maxHeight: "100vh", overflowY: "hidden" }}
          >
            <div className="fscp-header">
              <Breadcrumb
                style="margin-right:auto"
                addCls={"bgClr1"}
                items={breadcrumbItems}
                headerActions={<></>}
              />
              <Button
                btnColor={buttoncss.secondary}
                class_={buttoncss.greyBg}
                label={"Preview"}
                onClick={() => {
                  history.push(`/myfinV2/preview-sttemplate/${tempId}`);
                }}
              />
              {tab !== "general" && !isReadOnly && (
                <Button
                  btnColor={buttoncss.secondary_del}
                  class_={buttoncss.greyBg}
                  label={"Bin"}
                  icon={<DeleteIcon height={18} width={18} />}
                  onClick={() => {
                    // HandleSave();
                    setShowBin(tab);
                  }}
                  // isEnabled={1 != "view" || 2 != "approver"}
                />
              )}
              {!isReadOnly && (
                <>
                  <Button
                    btnColor={buttoncss.primary}
                    label={edit ? "Edit Changes" : "Save Changes"}
                    onClick={() => {
                      // HandleSave();
                      setHandleSave(tab);
                    }}
                    // isEnabled={1 != "view" || 2 != "approver"}
                  />

                  <Button
                    btnColor={buttoncss.primary}
                    label={"Override"}
                    onClick={() => {
                    }}
                    // isEnabled={1 != "view" || 2 != "approver"}
                  />
                </>
              )}
            </div>

            <div
              className={`${libcss.libBody} m-2`}
              style={{ overflow: "hidden" }}
            >
              <div style={{ "border-bottom": "0.5px solid #ddd" }}>
                <button
                  className={`tab-button ${tab === "general" ? "active" : ""}`}
                  style={{
                    "text-transform": "capitalize",
                    "border-bottom": "unset",
                  }}
                  onClick={() => {
                    setTab("general");
                  }}
                >
                  General
                </button>
                <button
                  className={`tab-button ${
                    tab === "hierarchy" ? "active" : ""
                  }`}
                  style={{
                    "text-transform": "capitalize",
                    "border-bottom": "unset",
                  }}
                  onClick={() => {
                    setTab("hierarchy");
                  }}
                >
                  Hierarchy
                </button>
                <button
                  className={`tab-button ${tab === "notes" ? "active" : ""}`}
                  style={{
                    "text-transform": "capitalize",
                    "border-bottom": "unset",
                  }}
                  onClick={() => {
                    setTab("notes");
                  }}
                >
                  Notes
                </button>
                <button
                  className={`tab-button ${tab === "cashflow" ? "active" : ""}`}
                  style={{
                    "text-transform": "capitalize",
                    "border-bottom": "unset",
                  }}
                  onClick={() => {
                    setTab("cashflow");
                  }}
                >
                  Cashflow
                </button>
                <button
                  className={`tab-button ${tab === "socie" ? "active" : ""}`}
                  style={{
                    "text-transform": "capitalize",
                    "border-bottom": "unset",
                  }}
                  onClick={() => {
                    setTab("socie");
                  }}
                >
                  SOCIE
                </button>
                <button
                  className={`tab-button ${
                    tab === "disclosures" ? "active" : ""
                  }`}
                  style={{
                    "text-transform": "capitalize",
                    "border-bottom": "unset",
                  }}
                  onClick={() => {
                    setTab("disclosures");
                  }}
                >
                  Disclosures
                </button>
              </div>

              {tab === "general" && (
                <GeneralTemplateInfo
                  templateData={templateData}
                  setHandleSave={setHandleSave}
                  handleSave={handleSave}
                  isReadOnly={isReadOnly}
                />
              )}
              {tab === "hierarchy" && templateData && (
                <Hierarchy
                  tempId={tempId}
                  showBin={showBin}
                  setShowBin={setShowBin}
                  isReadOnly={isReadOnly}
                />
              )}
              {tab === "notes" && templateData && (
                <Notes
                  tempId={tempId}
                  setHandleSave={setHandleSave}
                  handleSave={handleSave}
                  isReadOnly={isReadOnly}
                />
              )}
              {tab === "cashflow" && templateData && (
                <Cashflow
                  tempId={tempId}
                  setHandleSave={setHandleSave}
                  handleSave={handleSave}
                  isReadOnly={isReadOnly}
                />
              )}
              {tab === "socie" && templateData && (
                <Socie
                  tempId={tempId}
                  setHandleSave={setHandleSave}
                  handleSave={handleSave}
                  isReadOnly={isReadOnly}
                />
              )}
              {tab === "disclosures" && templateData && (
                <Disclosures
                  tempId={tempId}
                  setHandleSave={setHandleSave}
                  handleSave={handleSave}
                  isReadOnly={isReadOnly}
                />
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default ViewEditLibrary;
